"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ToolbarPlugin;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _LexicalComposerContext = require("@lexical/react/LexicalComposerContext");
var _lexical = require("lexical");
var _link = require("@lexical/link");
var _selection = require("@lexical/selection");
var _utils = require("@lexical/utils");
var _list = require("@lexical/list");
var _reactDom = require("react-dom");
var _richText = require("@lexical/rich-text");
var _code = require("@lexical/code");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var LowPriority = 1;
var supportedBlockTypes = new Set(["paragraph", "quote",
//"code",
"h1", "h2", "ul", "ol"]);
var blockTypeToBlockName = {
  code: "Code Block",
  h1: "Large Heading",
  h2: "Small Heading",
  h3: "Heading",
  h4: "Heading",
  h5: "Heading",
  ol: "Numbered List",
  paragraph: "Normal",
  quote: "Quote",
  ul: "Bulleted List"
};
function Divider() {
  return /*#__PURE__*/React.createElement("div", {
    className: "divider"
  });
}
function positionEditorElement(editor, rect) {
  if (rect === null) {
    editor.style.opacity = "0";
    editor.style.top = "-1000px";
    editor.style.left = "-1000px";
  } else {
    editor.style.opacity = "1";
    editor.style.top = "".concat(rect.top + rect.height + window.pageYOffset + 10, "px");
    editor.style.left = "".concat(rect.left + window.pageXOffset - editor.offsetWidth / 2 + rect.width / 2, "px");
  }
}
function FloatingLinkEditor(_ref) {
  var editor = _ref.editor;
  var editorRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  var mouseDownRef = (0, _react.useRef)(false);
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    linkUrl = _useState2[0],
    setLinkUrl = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isEditMode = _useState4[0],
    setEditMode = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    lastSelection = _useState6[0],
    setLastSelection = _useState6[1];
  var updateLinkEditor = (0, _react.useCallback)(function () {
    var selection = (0, _lexical.$getSelection)();
    if ((0, _lexical.$isRangeSelection)(selection)) {
      var node = getSelectedNode(selection);
      var parent = node.getParent();
      if ((0, _link.$isLinkNode)(parent)) {
        setLinkUrl(parent.getURL());
      } else if ((0, _link.$isLinkNode)(node)) {
        setLinkUrl(node.getURL());
      } else {
        setLinkUrl("");
      }
    }
    var editorElem = editorRef.current;
    var nativeSelection = window.getSelection();
    var activeElement = document.activeElement;
    if (editorElem === null) {
      return;
    }
    var rootElement = editor.getRootElement();
    if (selection !== null && !(nativeSelection !== null && nativeSelection !== void 0 && nativeSelection.isCollapsed) && rootElement !== null && rootElement.contains(nativeSelection.anchorNode)) {
      var domRange = nativeSelection === null || nativeSelection === void 0 ? void 0 : nativeSelection.getRangeAt(0);
      var rect;
      if ((nativeSelection === null || nativeSelection === void 0 ? void 0 : nativeSelection.anchorNode) === rootElement) {
        var inner = rootElement;
        while (inner.firstElementChild != null) {
          inner = inner.firstElementChild;
        }
        rect = inner.getBoundingClientRect();
      } else {
        rect = domRange === null || domRange === void 0 ? void 0 : domRange.getBoundingClientRect();
      }
      if (!mouseDownRef.current) {
        positionEditorElement(editorElem, rect);
      }
      setLastSelection(selection);
    } else if (!activeElement || activeElement.className !== "link-input") {
      positionEditorElement(editorElem, null);
      setLastSelection(null);
      setEditMode(false);
      setLinkUrl("");
    }
    return true;
  }, [editor]);
  (0, _react.useEffect)(function () {
    return (0, _utils.mergeRegister)(editor.registerUpdateListener(function (_ref2) {
      var editorState = _ref2.editorState;
      editorState.read(function () {
        updateLinkEditor();
      });
    }), editor.registerCommand(_lexical.SELECTION_CHANGE_COMMAND, function () {
      updateLinkEditor();
      return true;
    }, LowPriority));
  }, [editor, updateLinkEditor]);
  (0, _react.useEffect)(function () {
    editor.getEditorState().read(function () {
      updateLinkEditor();
    });
  }, [editor, updateLinkEditor]);
  (0, _react.useEffect)(function () {
    if (isEditMode && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditMode]);
  return /*#__PURE__*/React.createElement("div", {
    ref: editorRef,
    className: "link-editor"
  }, isEditMode ? /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    className: "link-input",
    value: linkUrl,
    onChange: function onChange(event) {
      setLinkUrl(event.target.value);
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        if (lastSelection !== null) {
          if (linkUrl !== "") {
            editor.dispatchCommand(_link.TOGGLE_LINK_COMMAND, linkUrl);
          }
          setEditMode(false);
        }
      } else if (event.key === "Escape") {
        event.preventDefault();
        setEditMode(false);
      }
    }
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "link-input"
  }, /*#__PURE__*/React.createElement("a", {
    href: linkUrl,
    target: "_blank",
    rel: "noopener noreferrer"
  }, linkUrl), /*#__PURE__*/React.createElement("div", {
    className: "link-edit",
    role: "button",
    tabIndex: 0,
    onMouseDown: function onMouseDown(event) {
      return event.preventDefault();
    },
    onClick: function onClick() {
      setEditMode(true);
    }
  }))));
}
function Select(_ref3) {
  var onChange = _ref3.onChange,
    className = _ref3.className,
    options = _ref3.options,
    value = _ref3.value;
  return /*#__PURE__*/React.createElement("select", {
    className: className,
    onChange: onChange,
    value: value
  }, /*#__PURE__*/React.createElement("option", {
    hidden: true,
    value: ""
  }), options.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      key: option,
      value: option
    }, option);
  }));
}
function getSelectedNode(selection) {
  var anchor = selection.anchor;
  var focus = selection.focus;
  var anchorNode = selection.anchor.getNode();
  var focusNode = selection.focus.getNode();
  if (anchorNode === focusNode) {
    return anchorNode;
  }
  var isBackward = selection.isBackward();
  if (isBackward) {
    return (0, _selection.$isAtNodeEnd)(focus) ? anchorNode : focusNode;
  } else {
    return (0, _selection.$isAtNodeEnd)(anchor) ? focusNode : anchorNode;
  }
}
function BlockOptionsDropdownList(_ref4) {
  var editor = _ref4.editor,
    blockType = _ref4.blockType,
    toolbarRef = _ref4.toolbarRef,
    setShowBlockOptionsDropDown = _ref4.setShowBlockOptionsDropDown;
  var dropDownRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var toolbar = toolbarRef.current;
    var dropDown = dropDownRef.current;
    if (toolbar !== null && dropDown !== null) {
      var _toolbar$getBoundingC = toolbar.getBoundingClientRect(),
        top = _toolbar$getBoundingC.top,
        left = _toolbar$getBoundingC.left;
      dropDown.style.top = "".concat(top + 40, "px");
      dropDown.style.left = "".concat(left, "px");
    }
  }, [dropDownRef, toolbarRef]);
  (0, _react.useEffect)(function () {
    var dropDown = dropDownRef.current;
    var toolbar = toolbarRef.current;
    if (dropDown !== null && toolbar !== null) {
      var handle = function handle(event) {
        var target = event.target;
        if (!dropDown.contains(target) && !toolbar.contains(target)) {
          setShowBlockOptionsDropDown(false);
        }
      };
      document.addEventListener("click", handle);
      return function () {
        document.removeEventListener("click", handle);
      };
    }
  }, [dropDownRef, setShowBlockOptionsDropDown, toolbarRef]);
  var formatParagraph = function formatParagraph() {
    if (blockType !== "paragraph") {
      editor.update(function () {
        var selection = (0, _lexical.$getSelection)();
        if ((0, _lexical.$isRangeSelection)(selection)) {
          (0, _selection.$wrapNodes)(selection, function () {
            return (0, _lexical.$createParagraphNode)();
          });
        }
      });
    }
    setShowBlockOptionsDropDown(false);
  };
  var formatLargeHeading = function formatLargeHeading() {
    if (blockType !== "h1") {
      editor.update(function () {
        var selection = (0, _lexical.$getSelection)();
        if ((0, _lexical.$isRangeSelection)(selection)) {
          (0, _selection.$wrapNodes)(selection, function () {
            return (0, _richText.$createHeadingNode)("h1");
          });
        }
      });
    }
    setShowBlockOptionsDropDown(false);
  };
  var formatSmallHeading = function formatSmallHeading() {
    if (blockType !== "h2") {
      editor.update(function () {
        var selection = (0, _lexical.$getSelection)();
        if ((0, _lexical.$isRangeSelection)(selection)) {
          (0, _selection.$wrapNodes)(selection, function () {
            return (0, _richText.$createHeadingNode)("h2");
          });
        }
      });
    }
    setShowBlockOptionsDropDown(false);
  };
  var formatBulletList = function formatBulletList() {
    if (blockType !== "ul") {
      editor.dispatchCommand(_list.INSERT_UNORDERED_LIST_COMMAND);
    } else {
      editor.dispatchCommand(_list.REMOVE_LIST_COMMAND);
    }
    setShowBlockOptionsDropDown(false);
  };
  var formatNumberedList = function formatNumberedList() {
    if (blockType !== "ol") {
      editor.dispatchCommand(_list.INSERT_ORDERED_LIST_COMMAND);
    } else {
      editor.dispatchCommand(_list.REMOVE_LIST_COMMAND);
    }
    setShowBlockOptionsDropDown(false);
  };
  var formatQuote = function formatQuote() {
    if (blockType !== "quote") {
      editor.update(function () {
        var selection = (0, _lexical.$getSelection)();
        if ((0, _lexical.$isRangeSelection)(selection)) {
          (0, _selection.$wrapNodes)(selection, function () {
            return (0, _richText.$createQuoteNode)();
          });
        }
      });
    }
    setShowBlockOptionsDropDown(false);
  };
  var formatCode = function formatCode() {
    if (blockType !== "code") {
      editor.update(function () {
        var selection = (0, _lexical.$getSelection)();
        if ((0, _lexical.$isRangeSelection)(selection)) {
          (0, _selection.$wrapNodes)(selection, function () {
            return (0, _code.$createCodeNode)();
          });
        }
      });
    }
    setShowBlockOptionsDropDown(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "editor-dropdown",
    ref: dropDownRef
  }, /*#__PURE__*/React.createElement("button", {
    className: "item",
    onClick: formatParagraph
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon paragraph"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, "Normal"), blockType === "paragraph" && /*#__PURE__*/React.createElement("span", {
    className: "active"
  })), /*#__PURE__*/React.createElement("button", {
    className: "item",
    onClick: formatLargeHeading
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon large-heading"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, "Large Heading"), blockType === "h1" && /*#__PURE__*/React.createElement("span", {
    className: "active"
  })), /*#__PURE__*/React.createElement("button", {
    className: "item",
    onClick: formatSmallHeading
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon small-heading"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, "Small Heading"), blockType === "h2" && /*#__PURE__*/React.createElement("span", {
    className: "active"
  })), /*#__PURE__*/React.createElement("button", {
    className: "item",
    onClick: formatBulletList
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon bullet-list"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, "Bullet List"), blockType === "ul" && /*#__PURE__*/React.createElement("span", {
    className: "active"
  })), /*#__PURE__*/React.createElement("button", {
    className: "item",
    onClick: formatNumberedList
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon numbered-list"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, "Numbered List"), blockType === "ol" && /*#__PURE__*/React.createElement("span", {
    className: "active"
  })), /*#__PURE__*/React.createElement("button", {
    className: "item",
    onClick: formatQuote
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon quote"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, "Quote"), blockType === "quote" && /*#__PURE__*/React.createElement("span", {
    className: "active"
  })));
}
function ToolbarPlugin() {
  var _useLexicalComposerCo = (0, _LexicalComposerContext.useLexicalComposerContext)(),
    _useLexicalComposerCo2 = _slicedToArray(_useLexicalComposerCo, 1),
    editor = _useLexicalComposerCo2[0];
  var toolbarRef = (0, _react.useRef)(null);
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    canUndo = _useState8[0],
    setCanUndo = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    canRedo = _useState10[0],
    setCanRedo = _useState10[1];
  var _useState11 = (0, _react.useState)("paragraph"),
    _useState12 = _slicedToArray(_useState11, 2),
    blockType = _useState12[0],
    setBlockType = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedElementKey = _useState14[0],
    setSelectedElementKey = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showBlockOptionsDropDown = _useState16[0],
    setShowBlockOptionsDropDown = _useState16[1];
  var _useState17 = (0, _react.useState)(""),
    _useState18 = _slicedToArray(_useState17, 2),
    codeLanguage = _useState18[0],
    setCodeLanguage = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isRTL = _useState20[0],
    setIsRTL = _useState20[1];
  var _useState21 = (0, _react.useState)(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isLink = _useState22[0],
    setIsLink = _useState22[1];
  var _useState23 = (0, _react.useState)(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isBold = _useState24[0],
    setIsBold = _useState24[1];
  var _useState25 = (0, _react.useState)(false),
    _useState26 = _slicedToArray(_useState25, 2),
    isItalic = _useState26[0],
    setIsItalic = _useState26[1];
  var _useState27 = (0, _react.useState)(false),
    _useState28 = _slicedToArray(_useState27, 2),
    isUnderline = _useState28[0],
    setIsUnderline = _useState28[1];
  var _useState29 = (0, _react.useState)(false),
    _useState30 = _slicedToArray(_useState29, 2),
    isStrikethrough = _useState30[0],
    setIsStrikethrough = _useState30[1];
  var _useState31 = (0, _react.useState)(false),
    _useState32 = _slicedToArray(_useState31, 2),
    isCode = _useState32[0],
    setIsCode = _useState32[1];
  var updateToolbar = (0, _react.useCallback)(function () {
    var selection = (0, _lexical.$getSelection)();
    if ((0, _lexical.$isRangeSelection)(selection)) {
      var anchorNode = selection.anchor.getNode();
      var element = anchorNode.getKey() === "root" ? anchorNode : anchorNode.getTopLevelElementOrThrow();
      var elementKey = element.getKey();
      var elementDOM = editor.getElementByKey(elementKey);
      if (elementDOM !== null) {
        setSelectedElementKey(elementKey);
        if ((0, _list.$isListNode)(element)) {
          var parentList = (0, _utils.$getNearestNodeOfType)(anchorNode, _list.ListNode);
          var type = parentList ? parentList.getTag() : element.getTag();
          setBlockType(type);
        } else {
          var _type = (0, _richText.$isHeadingNode)(element) ? element.getTag() : element.getType();
          setBlockType(_type);
          if ((0, _code.$isCodeNode)(element)) {
            setCodeLanguage(element.getLanguage() || (0, _code.getDefaultCodeLanguage)());
          }
        }
      }
      // Update text format
      setIsBold(selection.hasFormat("bold"));
      setIsItalic(selection.hasFormat("italic"));
      setIsUnderline(selection.hasFormat("underline"));
      setIsStrikethrough(selection.hasFormat("strikethrough"));
      setIsCode(selection.hasFormat("code"));
      setIsRTL((0, _selection.$isParentElementRTL)(selection));

      // Update links
      var node = getSelectedNode(selection);
      var parent = node.getParent();
      if ((0, _link.$isLinkNode)(parent) || (0, _link.$isLinkNode)(node)) {
        setIsLink(true);
      } else {
        setIsLink(false);
      }
    }
  }, [editor]);
  (0, _react.useEffect)(function () {
    return (0, _utils.mergeRegister)(editor.registerUpdateListener(function (_ref5) {
      var editorState = _ref5.editorState;
      editorState.read(function () {
        updateToolbar();
      });
    }), editor.registerCommand(_lexical.SELECTION_CHANGE_COMMAND, function (_payload, newEditor) {
      updateToolbar();
      return false;
    }, LowPriority), editor.registerCommand(_lexical.CAN_UNDO_COMMAND, function (payload) {
      setCanUndo(payload);
      return false;
    }, LowPriority), editor.registerCommand(_lexical.CAN_REDO_COMMAND, function (payload) {
      setCanRedo(payload);
      return false;
    }, LowPriority));
  }, [editor, updateToolbar]);
  var codeLanguges = (0, _react.useMemo)(function () {
    return (0, _code.getCodeLanguages)();
  }, []);
  var onCodeLanguageSelect = (0, _react.useCallback)(function (e) {
    editor.update(function () {
      if (selectedElementKey !== null) {
        var node = (0, _lexical.$getNodeByKey)(selectedElementKey);
        if ((0, _code.$isCodeNode)(node)) {
          node.setLanguage(e.target.value);
        }
      }
    });
  }, [editor, selectedElementKey]);
  var insertLink = (0, _react.useCallback)(function () {
    if (!isLink) {
      editor.dispatchCommand(_link.TOGGLE_LINK_COMMAND, "https://");
    } else {
      editor.dispatchCommand(_link.TOGGLE_LINK_COMMAND, null);
    }
  }, [editor, isLink]);
  return /*#__PURE__*/React.createElement("div", {
    className: "toolbar",
    ref: toolbarRef
  }, /*#__PURE__*/React.createElement("button", {
    disabled: !canUndo,
    onClick: function onClick() {
      editor.dispatchCommand(_lexical.UNDO_COMMAND, undefined);
    },
    className: "toolbar-item spaced",
    "aria-label": "Undo"
  }, /*#__PURE__*/React.createElement("i", {
    className: "format undo"
  })), /*#__PURE__*/React.createElement("button", {
    disabled: !canRedo,
    onClick: function onClick() {
      editor.dispatchCommand(_lexical.REDO_COMMAND, undefined);
    },
    className: "toolbar-item",
    "aria-label": "Redo"
  }, /*#__PURE__*/React.createElement("i", {
    className: "format redo"
  })), /*#__PURE__*/React.createElement(Divider, null), supportedBlockTypes.has(blockType) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: "toolbar-item block-controls",
    onClick: function onClick() {
      return setShowBlockOptionsDropDown(!showBlockOptionsDropDown);
    },
    "aria-label": "Formatting Options"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon block-type " + blockType
  }), /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, blockTypeToBlockName[blockType]), /*#__PURE__*/React.createElement("i", {
    className: "chevron-down"
  })), showBlockOptionsDropDown && /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/React.createElement(BlockOptionsDropdownList, {
    editor: editor,
    blockType: blockType,
    toolbarRef: toolbarRef,
    setShowBlockOptionsDropDown: setShowBlockOptionsDropDown
  }), document.body), /*#__PURE__*/React.createElement(Divider, null)), blockType === "code" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Select, {
    className: "toolbar-item code-language",
    onChange: onCodeLanguageSelect,
    options: codeLanguges,
    value: codeLanguage
  }), /*#__PURE__*/React.createElement("i", {
    className: "chevron-down inside"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      editor.dispatchCommand(_lexical.FORMAT_TEXT_COMMAND, "bold");
    },
    className: "toolbar-item spaced " + (isBold ? "active" : ""),
    "aria-label": "Format Bold"
  }, /*#__PURE__*/React.createElement("i", {
    className: "format bold"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      editor.dispatchCommand(_lexical.FORMAT_TEXT_COMMAND, "italic");
    },
    className: "toolbar-item spaced " + (isItalic ? "active" : ""),
    "aria-label": "Format Italics"
  }, /*#__PURE__*/React.createElement("i", {
    className: "format italic"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      editor.dispatchCommand(_lexical.FORMAT_TEXT_COMMAND, "underline");
    },
    className: "toolbar-item spaced " + (isUnderline ? "active" : ""),
    "aria-label": "Format Underline"
  }, /*#__PURE__*/React.createElement("i", {
    className: "format underline"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      editor.dispatchCommand(_lexical.FORMAT_TEXT_COMMAND, "strikethrough");
    },
    className: "toolbar-item spaced " + (isStrikethrough ? "active" : ""),
    "aria-label": "Format Strikethrough"
  }, /*#__PURE__*/React.createElement("i", {
    className: "format strikethrough"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: insertLink,
    className: "toolbar-item spaced " + (isLink ? "active" : ""),
    "aria-label": "Insert Link"
  }, /*#__PURE__*/React.createElement("i", {
    className: "format link"
  })), isLink && /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/React.createElement(FloatingLinkEditor, {
    editor: editor
  }), document.body), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      editor.dispatchCommand(_lexical.FORMAT_ELEMENT_COMMAND, "left");
    },
    className: "toolbar-item spaced",
    "aria-label": "Left Align"
  }, /*#__PURE__*/React.createElement("i", {
    className: "format left-align"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      editor.dispatchCommand(_lexical.FORMAT_ELEMENT_COMMAND, "center");
    },
    className: "toolbar-item spaced",
    "aria-label": "Center Align"
  }, /*#__PURE__*/React.createElement("i", {
    className: "format center-align"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      editor.dispatchCommand(_lexical.FORMAT_ELEMENT_COMMAND, "right");
    },
    className: "toolbar-item spaced",
    "aria-label": "Right Align"
  }, /*#__PURE__*/React.createElement("i", {
    className: "format right-align"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      editor.dispatchCommand(_lexical.FORMAT_ELEMENT_COMMAND, "justify");
    },
    className: "toolbar-item",
    "aria-label": "Justify Align"
  }, /*#__PURE__*/React.createElement("i", {
    className: "format justify-align"
  })), " "));
}